"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight, Play, CircleCheck, Mic, Activity } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FromVoiceToVelocity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section data-section-id="40265" id="the-driver-the-strategist" ref={ref} className={`dark bg-background text-foreground relative overflow-hidden py-20 lg:py-32 transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:24px_24px]"></div>
        {}
        <div className="absolute top-0 left-0 -translate-x-1/4 w-[600px] h-[600px] bg-primary/5 blur-[120px] rounded-full opacity-30"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          
          {}
          <div className="w-full lg:w-1/2 flex flex-col items-start text-left space-y-4">
            

            <h1 className="font-default font-bold tracking-tighter leading-[1.1] uppercase !text-6xl">AUTOPULSE:  OUR GOAL</h1>

            <p className="text-xl font-sans text-muted-foreground max-w-2xl leading-relaxed">A place where ethusiasts who live and breath automotive &amp; innovation. In an industry that is ever evolving at a quick pace, we strive to keep enthusiasts like ourselves informed, engaged, and motivated to do what we love, wether it is getting behind the wheel, or turning a wrench.&nbsp;</p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto pt-0">
              <Button size="lg" className="h-12 px-8 text-base shadow-lg shadow-primary/20 rounded-sm bg-primary hover:bg-primary/90 text-primary-foreground font-default" asChild>
                
              </Button>
              <Button size="lg" variant="ghost" className="h-12 px-8 text-base border border-white/10 hover:bg-white/5 rounded-sm font-default" asChild>
                
              </Button>
            </div>

            {}
            
          </div>

          {}
          <div className="w-full lg:w-1/2 relative">
            {}
            <div className="relative rounded-lg overflow-hidden border border-white/10 shadow-2xl">
              <img src="https://autopulseca.com/wp-content/uploads/2026/04/20250821_214540-scaled.jpg" alt="Automotive performance and innovation" className="w-full h-auto object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}